import { Component, Input } from '@angular/core';
import {
  AbstractControl,
  FormGroup,
  ReactiveFormsModule,
} from '@angular/forms';
import {
  CardModule,
  CheckboxModule,
  DropdownModule,
  RadioButtonModule,
  AlertModule,
  TooltipModule,
} from 'axis-components';
import { CommonModule, JsonPipe, SlicePipe } from '@angular/common';
import { BaseRules, Control, TextValues } from './west-virginia-model';
import { UimuiBaseStateComponent } from '../uimui-base-state.component';
import { RequestService } from '../../../_services/request/request.service';
import { TruncateModule } from 'axis-components/truncate';

@Component({
  selector: 'app-west-virginia',
  standalone: true,
  imports: [
    CardModule,
    CheckboxModule,
    CommonModule,
    DropdownModule,
    ReactiveFormsModule,
    RadioButtonModule,
    AlertModule,
    SlicePipe,
    TruncateModule,
    TooltipModule,
  ],
  templateUrl: './west-virginia.component.html',
  styleUrl: './west-virginia.component.scss',
})
export class WestVirginiaComponent extends UimuiBaseStateComponent<
  BaseRules,
  TextValues
> {
  constructor(private requestService: RequestService) {
    super();
  }

  @Input() set formGroup(form: FormGroup | null) {
    if (form) {
      super.getJsonRuleFiles('west-virginia', form);
      this.addPolicyDurationToPdfData();
    }
  }
  @Input() set isReview(review: boolean) {
    if (review) {
      super.getJsonRuleFiles('west-virginia', null);
      this.addPolicyDurationToPdfData();
    }
  }

  /**
   * Adds policy duration in months to the PDF data dump
   */
  private addPolicyDurationToPdfData(): void {
    try {
      const policyDurationMonths =
        this.requestService.getPolicyDurationInMonths();

      // Add the policy duration to the PDF data dump
      if (!this.baseRulesService.pdfDataDump['west-virginia']) {
        this.baseRulesService.pdfDataDump['west-virginia'] = {};
      }

      this.baseRulesService.pdfDataDump['west-virginia'] = {
        ...this.baseRulesService.pdfDataDump['west-virginia'],
        policyDurationMonths: policyDurationMonths,
      };
    } catch (error) {
      console.error('Error adding policy duration to PDF data:', error);
    }
  }

  onSelect(control: Control, selectionId: string): void {
    if (
      selectionId === 'IndividualState_CombinedSingleLimit' ||
      selectionId === 'IndividualState_Split'
    ) {
      if (control.formControlName === 'UMBIUMPD_CombinedSingleLimit_DropDown') {
        if (
          this.reactiveForm.get('UMBIUMPD_CombinedSingleLimit_DropDown')?.valid
        ) {
          this.reactiveForm
            .get('uMBIUMPD_LevelTwo_Radio')
            ?.setValue('CombinedSingleLimit_UMBIUMPD_LevelTwo_Radio');
        }
      }
      if (
        control.formControlName === 'UMBI_SplitLimits_DropDown' ||
        control.formControlName === 'UMPD_CombinedSingleLimit_DropDown'
      ) {
        if (
          this.reactiveForm.get('UMBI_SplitLimits_DropDown')?.valid &&
          this.reactiveForm.get('UMPD_CombinedSingleLimit_DropDown')?.valid
        ) {
          this.reactiveForm
            .get('uMBIUMPD_LevelTwo_Radio')
            ?.setValue('SplitLimits_UMBIUMPD_LevelTwo_Radio');
        }
      }
    }
  }

  ngAfterViewInit() {
    if (this.reactiveForm) {
      this.reactiveForm.controls['Vehicles_Input'].patchValue('1');
      this.reactiveForm.updateValueAndValidity();
    }
  }

  public getLiabilityLimit: string = '';

  /**
   * Provides state-specific lookup control names for premium calculation
   * @param control - The control to get lookup name for
   * @returns The lookup control name based on control type (UM or UIM)
   */
  protected override getLookupControlName(
    control: Control,
  ): string | undefined {
    const isUIM = control.formControlName.includes('UIM');
    const umdropdown = 'UMBIUMPD_CombinedSingleLimit_DropDown';
    const uimdropdown = 'UIMBIUIMPD_CombinedSingleLimit_DropDown';
    return isUIM ? uimdropdown : umdropdown;
  }

  override setupHookForDropDownData(){
    this.setupHookForLiabilityDropDownData();
  }
}
